module.exports = __webpack_public_path__ + "img/plus.e88b947c.png";